function getOtherCurrencyPrices()
{
  /**
  //{"data":[{"url":"/collections/oranges/products/abbott-bridesmaid-gown"},{"url":"/products/gift-card"},{"url":"/products/natalie-bridesmaid-dress-ivory"}]}
  var data = [];
  var mlvedaData = [];
  var mlvedaCallUrl = "//www.mlveda.com/ShopifyApps/ShopifyMultiPricing/getPrices?shop=gatherandgown.myshopify.com";
  setTimeout(function(){
    
    //checkShopifyFormatMoney(); console.log('just ran the default script!!!!!!!!!!!!!!!!!!'); return;
    
    
    console.log('dfsafdsafdasfdsrewrewr ' + $('div.product-index:visible').length);
    $('div.product-index:visible').each(function(event){
          var z = $(this).find('.prod-image').find('a').data('handle');
      	  z = '/products/' + z;
          if (z.indexOf('?') > -1)
            z = z.substring(0,z.indexOf('?'));
      		data.push({"url": z});
          console.log(z);
    });
    mlvedaData = {"data": data};
    
   var abcd = $m.ajax({
        url: mlvedaCallUrl,
        type: "POST",
        dataType: "json",
        timeout: 10000,
        data: {data: JSON.stringify(mlvedaData)},
        success: function(response) {
          console.log(response);
        },
        error: function(xhr, textStatus, errorThrown) {
            console.log(xhr);
          	console.log(textStatus);
          	console.log(errorThrown);
        }
   });
    
  }, 10000);**/
}

function setupAddToDressingRoom(productdata)
{
  //step 0 login or already logged in
	localStorage.setItem('_step1', 'dr');  //create or join dressing room modal
  	localStorage.setItem('_step1data', '');
	localStorage.setItem('_step2', 'addtodr');  //add product to dressing room
  	localStorage.setItem('_step2data', productdata);  //needs to be id^color format
}

function cancelSteps()
{
  localStorage.removeItem('_step1');
  localStorage.removeItem('_step1data');
  localStorage.removeItem('_step2');
  localStorage.removeItem('_step2data');
  localStorage.removeItem('_step3');
  localStorage.removeItem('_step3data');  
}

function processSteps()
{
  console.log('processSteps:  in');
  if (window.location.href.indexOf('create') > -1) //dont run this on dr create page
    return false;
  //return true to exit out of the calling function when returning
  
  var step1 = localStorage.getItem('_step1');
  var step1data = localStorage.getItem('_step1data');  
  //BEGIN some steps require to be logged in (all at this point) so test for logged in 
  //	and dont do anything yet if not logged in
  var mustbeloggedin = false;
    switch(step1) {
    case 'dr':
        mustbeloggedin = true;
        break;
    case 'addtodr':
        mustbeloggedin = true;
        break;
	}	
  console.log('processSteps:  ' + mustbeloggedin);
  if (mustbeloggedin)
    if ($('#currentemail').val().length == 0)
      return false;
  //END some steps require to be logged in (all at this point) so test for logged in 
  //	and dont do anything yet if not logged in  
  
  console.log('processSteps:  ' + step1);
  console.log('processSteps:  ' + step1data);
  localStorage.removeItem('_step1');  //create or join dressing room modal
  localStorage.removeItem('_step1data');
  
  if (localStorage.getItem('_step2') != null)
  {
  	localStorage.setItem('_step1', localStorage.getItem('_step2'));
    localStorage.removeItem('_step2');
  }
  if (localStorage.getItem('_step2data') != null)
  {
  	localStorage.setItem('_step1data', localStorage.getItem('_step2data'));  
    localStorage.removeItem('_step2data');
  }
  if (localStorage.getItem('_step3') != null)
  {
  	localStorage.setItem('_step2', localStorage.getItem('_step3'));
    localStorage.removeItem('_step3');
  }
  if (localStorage.getItem('_step3data') != null)
  {
  	localStorage.setItem('_step2data', localStorage.getItem('_step3data'));    
    localStorage.removeItem('_step3data');
  }
  
  switch(step1) {
    case 'dr':
        goToDressingRoom();
        break;
    case 'addtodr':
      	var arr = step1data.split('^')
        addtowishlistgo(arr[0],0,arr[1]);
        break;
	}	
  
  return false;
}